import { customerTicketing } from './customer-ticketing';

export const en = {
  customerTicketing,
};
